import { ReactNode, useState } from 'react';
import './AppError.css';
import * as Sentry from '@sentry/react';
import { EmptyState } from '@anticatrade/shared';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import SlButton from '@shoelace-style/shoelace/dist/react/button/index.js';

interface AppErrorProps {
	children: ReactNode;
	className?: string;
}

const AppError = ({ children, className }: AppErrorProps) => {
	const [isRetrying, setIsRetrying] = useState<boolean>(false);

	const location = useLocation();

	const { t } = useTranslation();

	return (
		<Sentry.ErrorBoundary
			key={location.pathname}
			fallback={({ resetError }) => (
				<EmptyState
					className={`app__error${className ? ' ' + className : ''}`}
					title={t('Something went wrong')}
					description={t(
						'Our team has been informed and will proceed to investigate and fix the issue',
					)}
					variant='danger'
					icon='exclamation-square-fill'
				>
					<SlButton
						variant='neutral'
						loading={isRetrying}
						onClick={() => {
							setIsRetrying(true);
							resetError();
							setTimeout(() => {
								setIsRetrying(false);
							}, 200);
						}}
					>
						{t('Retry')}
					</SlButton>
				</EmptyState>
			)}
			onError={(error, componentStack) => {
				console.error('Error:', error, componentStack);
			}}
		>
			{children}
		</Sentry.ErrorBoundary>
	);
};

export { AppError };
